import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';
import html2canvas from 'html2canvas';
import { MembershipInfo } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/models/membershipInfo';
import { ManageUsersService } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/services/manage-users.service';
export interface DialogData {
  userId: number;
}
@Component({
  selector: 'app-membership-card',
  standalone: false,
  templateUrl: './membership-card.component.html'
})
export class MembershipCardComponent implements OnInit {
  loading = false
  dataLoading = false
  @ViewChild('cardElement') cardElement!: ElementRef;
  membershipInfo: MembershipInfo = new MembershipInfo
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<MembershipCardComponent>,
    private service: ManageUsersService

  ) {

  }

  ngOnInit(): void {
    this.getMembershipInfo()

  }

  getMembershipInfo() {
    this.dataLoading = true;
    let data: any = {}
    if (this.data.userId != 0) data.userId = this.data.userId
    this.dataLoading = true;
    this.service.getMembershipInfo(data).subscribe(
      (res: MembershipInfo) => {
        this.dataLoading = false;
        this.membershipInfo = res;
      }, (error: any) => {
        console.log('Faild');
      });
  }

  print() {
    window.print();
    // this.loading = true
    // const element = this.cardElement.nativeElement;

    // html2canvas(element, {
    //   scale: 3,
    //   useCORS: true,
    //   backgroundColor: null,
    //   logging: false
    // }).then((canvas) => {
    //   canvas.toBlob((blob) => {
    //     if (blob) {
    //       FileSaver.saveAs(blob, 'MemberCard_2026.png');
    //     }
    //   }, 'image/png');
    // }).catch(err => {
    //   console.error('حدث خطأ أثناء المعالجة:', err);
    // });
  }

}
